import React from "react";
import { advantages, trust } from "../data";
import SectionHead from "./SectionHead";
import useReveal from "../hooks/useReveal";

function AdvCard({ a, i }) {
  const [ref, visible] = useReveal();
  return (
    <article
      ref={ref}
      className={`adv__card reveal ${visible ? "is-visible" : ""}`}
      style={{ "--d": `${(i % 3) * 0.1}s` }}
    >
      <h3>{a.title}</h3>
      <div className="adv__row adv__row--op">
        <span className="tag tag--op">Operațional</span>
        <p>{a.op}</p>
      </div>
      <div className="adv__row adv__row--fin">
        <span className="tag tag--fin">Financiar</span>
        <p>{a.fin}</p>
      </div>
    </article>
  );
}

export default function Advantages() {
  return (
    <section className="adv" id="avantaje">
      <SectionHead
        kicker="De ce leasing operațional"
        title="Operațional vs. financiar: diferența care contează"
      >
        Leasingul financiar îți aduce o mașină în proprietate, dar și toate
        grijile care vin cu ea. Leasingul operațional îți dă mobilitatea, fără
        riscuri și fără costuri ascunse.
      </SectionHead>

      <div className="adv__grid">
        {advantages.map((a, i) => (
          <AdvCard a={a} i={i} key={i} />
        ))}
      </div>

      <ul className="adv__trust">
        {trust.map((t, i) => (
          <li key={i}>
            <CheckIcon />
            {t}
          </li>
        ))}
      </ul>
    </section>
  );
}

function CheckIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}
